import { ROUTE_ACCOUNT_MY_LIMITS } from '~/components/router/constants';
import { LIMITS_SCREEN } from '~/components/account/limits/responsible-gaming/constants';
import { LimitPopupAction, LIMIT_POPUP_ACTIONS, LimitType } from '~/components/limits/types';

export const LIMITS_REMAINING_AMOUNT_ENDPOINT = '/PaymentFormDataService/checkLimits/remainingAmount';
export const SPENDING_LIMITS_NOTIFICATION_ENDPOINT = '/PaymentFormDataService/getSpendingLimitsNotification';

export const textKeys = [
	'MOBILE_HEADER_BAR_DEPOSIT',
	'MOBILE_RESPONSIBLE_MONTHLY_LIMIT',
	'MOBILE_RESPONSIBLE_LIMIT_REMAINING',
	'MOBILE_VERIFY_WITH_BANK',
	'MOBILE_KREDITZ_TITLE',
	'MOBILE_SPENDING_LIMIT_REACHED_TITLE',
	'MOBILE_SPENDING_LIMIT_REACHED_SUBTITLE',
	'MOBILE_SPENDING_LIMIT_REACHED_SUMMARY',
	'MOBILE_SPENDING_LIMIT_NEVER_CHECK_MESSAGE',
	'MOBILE_SPENDING_LIMIT_LATEST_CHECK_MESSAGE',
	'MOBILE_SPENDING_LIMIT_LATEST_CHECK_MESSAGE_PART2',
	'MOBILE_SPENDING_LIMIT_VERIFICATION_SUCCESS_WAIT',
	'MOBILE_SPENDING_LIMIT_VERIFICATION_SUCCESS_NEW_LIMIT',
	'DIALOG_LOADING',
	'MOBILE_UPLOAD_DOCUMENTS',
	'MOBILE_GENERAL_ERROR',
	'MOBILE_SPENDING_LIMIT_APPROVAL_IN_PROGRESS',
	'MOBILE_DEPOSIT_LIMIT_REACHED_TITLE',
	'MOBILE_BALANCE_LIMIT_REACHED_TITLE',
	'MOBILE_DEPOSIT_LIMIT_REACHED_SUBTITLE',
	'MOBILE_BALANCE_LIMIT_REACHED_SUBTITLE',
	'MOBILE_SPEND_LIMIT_REACHED_TITLE',
	'MOBILE_SPEND_LIMIT_REACHED_SUBTITLE',
	'MOBILE_SPEND_VIEW_LIMITS',
	'MOBILE_DEPOSIT_VIEW_LIMITS',
	'MOBILE_BALANCE_VIEW_LIMITS',
	'MOBILE_SPENDING_LIMIT_OR_TEXT',
	'MOBILE_SPENDING_LIMIT_VERIFICATION_FAILED'
];

export const SPEND = 'SPEND';
export const DEPOSIT = 'DEPOSIT';
export const BALANCE = 'BALANCE_LIMIT';

export const animationVariants = {
	open: { opacity: 1, y: 0 },
	closed: { y: 300, opacity: 0 },
	exit: { y: 300, opacity: 0 }
};

export const animationTransition = {
	x: { type: 'spring' as const, stiffness: 200, damping: 20 },
	opacity: { duration: 0.2 }
};

export const getLimitsContent = (type?: string) => {
	switch (type) {
		case SPEND:
			return {
				title: 'MOBILE_SPEND_LIMIT_REACHED_TITLE',
				subTitle: 'MOBILE_SPEND_LIMIT_REACHED_SUBTITLE',
				buttonText: 'MOBILE_SPEND_VIEW_LIMITS',
				navigateUrl: `${ROUTE_ACCOUNT_MY_LIMITS}/${LIMITS_SCREEN.SPEND}`
			};
		case BALANCE:
			return {
				title: 'MOBILE_BALANCE_LIMIT_REACHED_TITLE',
				subTitle: 'MOBILE_BALANCE_LIMIT_REACHED_SUBTITLE',
				buttonText: 'MOBILE_BALANCE_VIEW_LIMITS',
				navigateUrl: `${ROUTE_ACCOUNT_MY_LIMITS}/${LIMITS_SCREEN.BALANCE}`
			};

		default:
			return {
				title: 'MOBILE_DEPOSIT_LIMIT_REACHED_TITLE',
				subTitle: 'MOBILE_DEPOSIT_LIMIT_REACHED_SUBTITLE',
				buttonText: 'MOBILE_DEPOSIT_VIEW_LIMITS',
				navigateUrl: `${ROUTE_ACCOUNT_MY_LIMITS}/${LIMITS_SCREEN.DEPOSIT}`
			};
	}
};

export const getLimitPopupTracking = (
	limitType: LimitType = DEPOSIT,
	action: LimitPopupAction = LIMIT_POPUP_ACTIONS.VIEW
) => {
	const formattedType = limitType?.toLowerCase();

	return {
		pixel_screen: 'account-page',
		pixel_deposit_action: `${formattedType}-limits-reached-popup-${action}`
	};
};
